module.exports = __webpack_public_path__ + "img/add.359ad9ea.png";